import {
  FETCH_PRACTITIONAR_REQUEST,
  FETCH_PRACTITIONAR_SUCCESS,
  FETCH_PRACTITIONAR_FAILURE,
} from "./practitionerTypes";

const initialState = {
  loading: false,
  practitioner: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRACTITIONAR_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_PRACTITIONAR_SUCCESS:
      return {
        loading: false,
        practitioner: action.payload,
        error: "",
      };
    case FETCH_PRACTITIONAR_FAILURE:
      return {
        loading: false,
        practitioner: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
